module.exports = __webpack_public_path__ + "static/media/hair-dye-kit.b53cdfcb.svg";